import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';

export default function () {
  const pageable = usePageable();

  const filters = ref({
    siteId: {value: null},
    officeId: {value: null},
    roamingTeamId: {value: null},
    userId: {value: null},
    requestId: {value: null},
    start: {value: null},
    end: {value: null},
    validated: {value: null},
    status: {value: []},
  });

  function getQueryParams() {
    const params = pageable.getQueryParams();

    if (filters.value.siteId?.value) {
      params['siteId'] = filters.value.siteId.value;
    }

    if (filters.value.officeId?.value) {
      params['officeId'] = filters.value.officeId.value;
    }

    if (filters.value.roamingTeamId?.value) {
      params['roamingTeamId'] = filters.value.roamingTeamId.value;
    }

    if (filters.value.requestId?.value) {
      params['requestId'] = filters.value.requestId.value;
    }

    if (filters.value.userId?.value) {
      params['userId'] = filters.value.userId.value;
    }

    if (filters.value.start?.value) {
      params['start'] = filters.value.start.value.toISOString();
    }

    if (filters.value.end?.value) {
      params['end'] = filters.value.end.value.toISOString();
    }

    if (filters.value.validated?.value != null) {
      params['validated'] = filters.value.validated.value;
    }

    if (filters.value.status?.value.length > 0) {
      params['status'] = filters.value.status.value.join(',');
    }

    return params;
  }

  return {
    pageable,
    filters,
    getQueryParams,
  }
}


